var navApp;

navApp = angular.module('navApp', ['ngAnimate', 'ngSanitize']).factory('_', [
  '$window', function($window) {
    return $window._;
  }
]).factory('hoverIntent', [
  '$window', function($window) {
    return $window.hoverIntent;
  }
]).factory('endpointDomain', [
  '$window', function($window) {
    if (($window.ngNavData.endpointDomain != null) && $window.ngNavData.endpointDomain.length > 0) {
      return $window.ngNavData.endpointDomain;
    } else {
      return '/';
    }
  }
]).factory('businessUnitBranch', [
  '$window', function($window) {
    return $window.ngNavData.businessUnitBranch;
  }
]).constant('templatePrefix', '/typo3conf/ext/t3site/Sites/Main/Resources/Assets/Script/Coffeescript/Nav/templates').constant('animateSpeed', 300);

navApp.factory('templatePath', [
  'templatePrefix', function(templatePrefix) {
    return function(file) {
      return templatePrefix + "/" + file;
    };
  }
]);
